import React from "react";
 import  { useState, useEffect } from 'react';
 import { DataGrid } from '@mui/x-data-grid';
 import { configData } from "../config";
 import { Link } from '@mui/material';
import { Helmet } from 'react-helmet';
import './classes/ManageOrders.css';
import SalespersonSidebar from "./SalespersonSidebar";
import Loading from './Loading';


 
 const columns = [   
   {
     field: 'order_number',
     headerName: 'Order number',     
     minWidth: 123,
     flex:1,
     sortable: false,
          renderCell: (params) => (
     <Link href={params.row.order_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
         {params.row.order_number}
       </Link>
   ),
     
   },
   {
     field: 'updated',
     headerName: 'Updated',      
     minWidth: 184, 
     flex:1, 
     sortable: false,    
   },
   {
     field: 'user',
     headerName: 'User',     
     minWidth: 300, 
     flex:1,
     sortable: false,
          renderCell: (params) => (
     <Link href={params.row.user_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
         {params.row.user}
       </Link>
   ),
     
   },
     {
        field: 'total',
        headerName: 'Total',        
        minWidth: 75, 
        flex:1,
        sortable: false,        
     },
    {
        field: 'order_status',
        headerName: 'Order Status',
        sortable: false,  
        minWidth: 111, 
        flex:1, 
 
     },
   
    ]; 

const ManageOrders =() =>{

  const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const [isLoading, setIsLoading] = useState(true);
const app_url = configData.APP_URL;
   const initialForm = {                  
     order_id:''   
     };     
      const [formData, setFormData] = useState(initialForm);

  const [appliedFormData, setAppliedFormData] = useState({
        order_id:'' 
      });

const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    
  };
  React.useEffect(() => {
    const fetchData = async () => {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
       try {
      const response = await fetch(app_url+'orderdetails/getlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          //formData:formData
          formData:appliedFormData,
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };
    

    fetchData();
  }, [paginationModel, sortModel, filterModel,appliedFormData]); // Re-fetch data when these change


  /* Pagination, filter config ends here */

const handleSubmit = async (e) => {
  e.preventDefault();
  setPaginationModel({
                 page: 0,
                    pageSize: 50,
                 });
                 setAppliedFormData({ ...formData });
  try {
     setIsLoading(true);
const response = await fetch(app_url+'orderdetails/getlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: 0,
          pageSize: 50,
          sortModel,
          filterModel,
          formData:formData
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
  
}; 
 
    return(
        <>
         {isLoading ? (
              <Loading />
            ) : (
        <div id="main">
            <Helmet><title>Order List</title></Helmet>
           <div class="left"></div>   
               <div class="center left-center">
                 <h1>Order List</h1>
                    <div className="manage-orders-container">
                     
                        <form>
                            <label htmlFor="order_id">Order ID</label>
                              <input
                                type="text"
                                name="order_id"
                                id="order_id"
                                value={formData.order_id}
                                onChange={handleChange}
                                />                                                                   
                            <button className='form-submit' type="submit" onClick={handleSubmit}>Apply</button>
                        </form>                       
                    </div>                      
                    <div className="manage-orders-table-container">
                       <table>
                                <div style={{ width: '100%' }}>
                                    <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        rowCount={rowCount}
                                        paginationMode="server"
                                        sortingMode="server"
                                        filterMode="server"
                                        paginationModel={paginationModel}
                                        onPaginationModelChange={setPaginationModel}
                                        sortModel={sortModel}
                                        onSortModelChange={setSortModel}
                                        filterModel={filterModel}
                                        onFilterModelChange={setFilterModel}
                                        pageSizeOptions={[5, 10, 25,50]}
                                        getRowId={() => crypto.randomUUID()}
                                        getRowHeight={() => 'auto'}
                                        disableColumnFilter 
                                        disableColumnResize={true}
                                    />
                                </div>
                       </table>
                    </div>
                </div>
            <div class="right">
                <SalespersonSidebar/>
            </div>
        </div>
        
     )}
    </>
  )
};

export default ManageOrders;